import { ReactNode } from "react";
import { Box } from "@material-ui/core";
import useWindowSize from "../../hooks/useWindowSize";

export interface DailyMetric {
  icon: ReactNode;
  value: ReactNode;
  label: string;
}

// "Daily Trucks" metric row. Renders on a single line on desktop and as a 2-per-row
// (2x2) grid on mobile, with a consistent standard font size and an icon on every
// metric. Used across all workstream dashboards for a uniform look.
const DailyMetrics = ({ metrics }: { metrics: DailyMetric[] }) => {
  const { isMobile } = useWindowSize();

  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      style={{
        gap: isMobile ? 8 : 20,
        fontSize: "0.875rem",
      }}
    >
      {metrics.map((m) => (
        <Box
          key={m.label}
          display="flex"
          alignItems="center"
          style={{
            whiteSpace: "nowrap",
            flex: isMobile ? "0 0 45%" : "0 0 auto",
          }}
        >
          {m.icon}
          <b style={{ marginLeft: 4 }}>{m.value}</b>
          <span style={{ marginLeft: 6 }}>{m.label}</span>
        </Box>
      ))}
    </Box>
  );
};

export default DailyMetrics;
